import PageContent from '../../components/PageContent';
import { useEffect, useState } from 'react';
import ProjectTable from '../../components/ProjectTable';
import { useSelector } from 'react-redux';
import { currentKeyword } from '../../features/search/searchSlice';
import {getProjectsList} from "../../api/Projects";

const Search = () => {
  const _currentKeyWord = useSelector(currentKeyword);
  const [keyword, setKeyword] = useState(_currentKeyWord);

  const [tableData, setTableData] = useState([]);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setKeyword(_currentKeyWord);
  }, [_currentKeyWord]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await getProjectsList({
          keyword,
          page: 1,
          pageSize: 10,
        });
        setPageOptions({
          ...pageOptions,
          total: data.total,
          currentPage: data.current_page,
          perSize: data.per_page,
        });
        for (let i = 0; i < data.list.length; i++) {
          data.list[i].key = i;
        }
        setTableData(data.list);
      } catch (_error) {
        // console.log('_error', _error);
      }
      setLoading(false);
    };
    fetchData();
  }, [keyword]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (page, pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setLoading(true);
    getProjectsList({
      page,
      pageSize,
    })
      .then(({ data }) => {
        for (let i = 0; i < data.list.length; i++) {
          data.list[i].key = i;
        }
        setPageOptions({
          ...pageOptions,
          total: data.total,
          currentPage: data.current_page,
          perSize: data.per_page,
        });
        setTableData(data.list);
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
      });
  };

  return (
    <PageContent>
      <ProjectTable
        data={tableData}
        loading={loading}
        pagination={{
          position: ['bottomLeft'],
          total: pageOptions.total,
          current: pageOptions.currentPage,
          pageSize: pageOptions.perSize,
          onChange: (page, pageSize) => {
            handlePageChange(page, pageSize);
          },
        }}
      />
    </PageContent>
  );
};

export default Search;
